import { useQuery } from '@tanstack/react-query'
import { getThumbnailPlacid } from '../../service/list'

function useGetThumbnailPlacid() {
  return useQuery({
    queryKey: ['get-thumbnail-list-placid'],
    queryFn: () => getThumbnailPlacid(),
    staleTime: 6 * 1000,
  })
}

export default useGetThumbnailPlacid
